module.exports = __webpack_public_path__ + "img/mapg.80a16a1d.png";